import React, { Component } from 'react';
import ReactTable from 'react-table';
import '../../../assets/css/applicationSettings.css';
import { docsColumns, notesColumns  } from '../Applications/applicationTestData';

class NotesAndDocuments extends Component {
    constructor(props) {
        super(props);
        const selectedRowValues = this.props.selectedRowValues || {};
        this.state = {
            activeTab: 'notes',
            currentObj: selectedRowValues,
            newNote: '',
            notes: selectedRowValues.notes || [],
            documents: selectedRowValues.documents || [],
            newDocumentDesc: '',
            newFile: null,
        };
    }
    componentDidUpdate(prevProps) {
        if (
            prevProps.notesAndDocumentsData !== this.props.notesAndDocumentsData
        ) {
            this.setState({
                notes: this.props.notesAndDocumentsData.notes || [],
                documents: this.props.notesAndDocumentsData.documents || []
            });
         }
    }

    handleTabChange(tab) {
        this.setState({ activeTab: tab });
    }
    
    handleNoteChange = (event) => {
        console.log("Note: ", this.state.currentObj)
        this.setState({ newNote: event.target.value });
    };

    handleAddNote = (e) => {
        e.preventDefault();
        if (!this.state.newNote.trim()) {
            return;
        }
        this.props.onPutApiCall("notes", this.state.newNote);
        this.setState({ newNote: "" });
    };

    handleAddDocument = (e) => {
        e.preventDefault();
        if (!this.state.newFile) {
            return;
        }
        this.props.onPutApiCall("documents", this.state.newFile);
        this.setState({newDocumentDesc: "", newFile: null });
   };

    handleFileChange = (e) => {
        const file = e.target.files[0];
        this.setState({ newFile: file, newDocumentDesc: file.name });
    };


    render() {
        const { onClose, notesAndDocumentsData } = this.props;
        const documentColumnIndex = docsColumns.findIndex((column) => column.accessor === 'documentDesc');
        const updatedDocsColumns = [...docsColumns];
        updatedDocsColumns[documentColumnIndex] = {
            Header: () => (
                <div style={{ textAlign: 'center', whiteSpace: 'normal' }}>
                    Documents <br />
                </div>
            ),
            accessor: 'documentDesc',
                 Cell: ({ value, row }) => {
                   const documentLink = row._original.documentLink;
                   const documentName = value ? value : documentLink.split("/").pop().split("-").pop();
                   const handleDocumentClick = (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        window.open(documentLink, '_blank', 'noopener,noreferrer');
                    };
                    return (
                        <div style={{ textAlign: 'center' }}>
                            <a
                                href={documentLink}
                                onClick={handleDocumentClick}
                                style={{ cursor: 'pointer' }}
                            >
                                {documentName}
                            </a>
                        </div>
                    );
                },
            width: 100,
        };
    return (
        <div className="dialog-container">
            <div className="dialog-close" onClick={onClose}>
                <span>&times;</span>
            </div>
            <div className="dialog-title">Documents and Notes</div>
            <div className="dialog-tabs">
            <div
                className={`dialog-tab ${this.state.activeTab === 'notes' ? 'active' : ''}`}
                onClick={() => this.handleTabChange('notes')}
            >
                Notes
            </div>
            <div
                className={`dialog-tab ${this.state.activeTab === 'documents' ? 'active' : ''}`}
                onClick={() => this.handleTabChange('documents')}
            >
                Documents
            </div>
            </div>
            <div className="dialog-tab-content">
                {this.state.activeTab === 'notes' && (
                    <form>
                        <input className="form-control" type="text" value={this.state.newNote} onChange={this.handleNoteChange} required/>
                        <button className="bg-color-3 btn btn-sm small" onClick={(e) => this.handleAddNote(e)}>Add Notes</button>
                        <ReactTable className="-striped -highlight"
                            ref={r => (this.checkboxTable = r)}
                            data={this.props.notesAndDocumentsData.notes || []}
                            columns={notesColumns}
                            defaultPageSize={8}
                            showPagination={false}
                            showPaginationTop={false}
                            showPaginationBottom={false}
                        />
                    </form>
                )}
                {this.state.activeTab === 'documents' && ( 
                    <form>
                        <input className="form-control" placeholder='Add Note' type="file" onChange={this.handleFileChange} required/>
                        <button className="btn btn-sm small bg-color-3" onClick={(e) => this.handleAddDocument(e)}>Add Document</button> 
                        <ReactTable className="-striped -highlight"
                            ref={r => (this.checkboxTable = r)}
                            data={this.props.notesAndDocumentsData.documents || []}
                            columns={updatedDocsColumns}
                            defaultPageSize={8}
                            showPagination={false} 
                            showPaginationTop={false}
                            showPaginationBottom={false}
                        />
                    </form>
                )}
            </div>
        </div>
    );
  }
}

export default NotesAndDocuments;



// WEBPACK FOOTER //
// ./src/components/District/applicationVerification/notesAndDocuments.jsx